import { v4 as uuidv4 } from "uuid";
import type { Contact } from "@freightsimple/generated-dashboard-openapi-client/models/Contact";
import type { Location } from "@freightsimple/generated-dashboard-openapi-client/models/Location";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import { useSavedLocationsService } from "../Services/LocationsSavedService";

export function useLocationsCreateSavedLocationFromShipment() {
  const savedLocationsService = useSavedLocationsService();

  /**
   * Creates a new SavedLocation and saves it to the address book
   * @param location
   * @param contact
   * @param isFavorite
   * @returns The savedLocationId of the newly created location
   */
  async function createSavedLocation(
    location: Location,
    contact: Contact,
    isFavorite: boolean = false,
  ): Promise<string> {
    const newLocationId = uuidv4();
    const newContactId = uuidv4();

    const newSavedLocation: SavedLocation = {
      savedLocationId: newLocationId,
      location: location,
      contacts: [
        {
          savedContactId: newContactId,
          savedLocationId: newLocationId,
          contact: contact,
        },
      ],
      defaultSavedContactId: newContactId,
      isFavourite: isFavorite,
      isBranch: false,
    };

    await savedLocationsService.addLocation(newSavedLocation);

    return newLocationId;
  }

  return createSavedLocation;
}
